import { Request } from '../config/requests';
import { getToken } from '../config/token';

const token = getToken();

export async function recordImage(files, { claimId, policyId } = {}) {
  const fd = new FormData();
  files.forEach((element) => {
    fd.append('files', element);
  });

  const params = new URLSearchParams();
  if (claimId) params.append('claimId', claimId);
  if (policyId) params.append('policyId', policyId);
  const query = params.toString() ? `?${params.toString()}` : '';

  return await Request({
    method: 'post',
    token: token,
    route: `api/claims/upload_files${query}`,
    formData: fd,
  });
}
